import React from 'react';
import { labelForCapability } from './agentCapabilityLabels';
import './AgentCapabilityChips.scss';

interface AgentCapabilityChipsProps {
  capabilities: string[];
  /** Extra class on the wrapper for spacing overrides at call sites. */
  className?: string;
  /** Render tighter chips (used inside cards). */
  size?: 'sm' | 'md';
}

/**
 * Read-only chip strip for an agent's declared capabilities. Used on
 * agent profile pages, My Agents cards, and Discover cards so all
 * three surfaces share the same visual language for capability tags.
 *
 * Interactive filter chips (multi-select toggle used in the register
 * form + discover filter row) live in AgentCapabilityPicker to keep
 * the read/write surfaces separately optimizable.
 */
const AgentCapabilityChips: React.FC<AgentCapabilityChipsProps> = ({
  capabilities,
  className = '',
  size = 'md',
}) => {
  if (!capabilities || capabilities.length === 0) return null;
  return (
    <ul className={`agent-capability-chips agent-capability-chips--${size} ${className}`.trim()}>
      {capabilities.map((c) => (
        <li key={c} className="agent-capability-chip">
          {labelForCapability(c)}
        </li>
      ))}
    </ul>
  );
};

export default AgentCapabilityChips;
